import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 20px 40px;
  overflow: auto;
  width: 90vw;
  max-height: 90vh;
`
